import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MUIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MU" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#579D20"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G fillRule="evenodd" clipRule="evenodd" mask="url(#b)">
        <Path fill="#FECA00" d="M0 6v3h16V6H0Z" />
        <Path fill="#3D58DB" d="M0 3v3h16V3H0Z" />
        <Path fill="#E11C1B" d="M0 0v3h16V0H0Z" />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
